module.exports = "precision mediump float;\r\n\r\nattribute vec2 a_position;\r\nvarying vec2 v_position;\r\n\r\nvoid main() {\r\n  v_position=(a_position+1.0)*0.5;\r\n  v_position.y=1.0-v_position.y;\r\n  gl_Position = vec4(a_position,0.0,1.0);\r\n}\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./shaders/simple.vert
 ** module id = 6
 ** module chunks = 0 1 2 3
 **/